import { hydrateMemberFromLookup } from "../../member/deactivatedMemberOwner";
import { Members } from "../../member/useMembers";
import { FolderTreeItem } from "../useQueryFolderTree";

interface Options {
  /** Pass `useMembers().isPending` so in-flight lookups do not resolve to the deactivated placeholder. */
  isMembersPending?: boolean;
}

export function mapOwnersToFolders(
  folders: FolderTreeItem[],
  members: Members,
  { isMembersPending = false }: Options = {},
) {
  let hydratedFolders = folders;

  if (members) {
    hydratedFolders = folders.map((folder) => {
      if (!folder.ownerId) {
        return folder;
      }

      let children = folder.children || [];
      if (folder.children?.length) {
        (children as FolderTreeItem[]) = mapOwnersToFolders(
          folder.children as FolderTreeItem[],
          members,
          { isMembersPending },
        );
      }

      const owner = hydrateMemberFromLookup(members, folder.ownerId, {
        deferDeactivatedUntilMembersResolve: true,
        isMembersPending,
      });

      return {
        ...folder,
        ...(children.length > 0 ? { children } : {}),
        owner,
      };
    });
  }

  return hydratedFolders;
}
